/* Presentation adapter for the existing Mori email campaign.
 * Native submission, validation, code delivery and dismissal stay with Mori.
 */
(() => {
  document.addEventListener('fv:reward-ready', event => {
    const config = event.detail;
    const popup = document.getElementById('scratch-popup');
    const template = document.getElementById('fv-reward-art');
    if (!popup || !template || popup.dataset.fvReward || Number(config.campaignId) !== 658 ||
        config.flowMode !== 'email' || !config.requireEmail || config.collectPhone) return;
    popup.dataset.fvReward = 'true';
    const media = popup.querySelector('.sp-split-media');
    if (!media) return;
    media.append(template.content.cloneNode(true));
    popup.classList.add('fv-reward');
    const setText = (id, text) => { const el = document.getElementById(id); if (el) el.textContent = text; };
    function prepare() {
      if (!popup.open) return;
      setText('sp-eyebrow', 'A FANNIVERSE WELCOME');
      setText('sp-headline', `Enjoy ${config.discountLabel} your first order.`);
      setText('sp-body-text', 'Join the FANNIVERSE community for product updates, studio stories and exclusive offers.');
      setText('sp-email-btn', 'Unlock my offer');
      setText('sp-decline-btn', 'No, thanks');
      const input = document.getElementById('sp-email-input');
      input.disabled = false;
      input.placeholder = 'Email address';
      input.setAttribute('aria-label', 'Email address');
      const canvas = document.getElementById('sp-canvas');
      if (canvas) canvas.classList.add('revealed');
    }
    // Only observe the native dialog's open flag, never the document subtree.
    const onOpen = () => {
      if (popup.open) requestAnimationFrame(() => requestAnimationFrame(prepare));
    };
    new MutationObserver(onOpen).observe(popup, { attributes: true, attributeFilter: ['open'] });
    onOpen();
  }, { once: true });
})();
